"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPrimaryBankComponent = void 0;
const core_1 = require("@angular/core");
const account_service_1 = require("../services/account.service");
const __1 = require("../");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const common_1 = require("@angular/common");
class CSPrimaryBankComponent {
    constructor(modalService, accountService, accountDetailService, titlecasePipe) {
        this.modalService = modalService;
        this.accountService = accountService;
        this.accountDetailService = accountDetailService;
        this.titlecasePipe = titlecasePipe;
        this.bankJson();
        this.newBankDetails = this.bankDetails;
        this.edit = 'no';
        this.showNewBankAcc = false;
        this.bankDetails.setPrimaryPayment = false;
        this.bankDetails.bankCheckType = 'Consumer';
        this.checkType_edit_saved = 'Consumer';
        this.ssnBox = 'false';
    }
    bankJson() {
        this.bankDetails = {
            bankAccount: {
                routingNumber: '',
                routingNumberConfirm: '',
                accountNumber: '',
                accountNumberConfirm: '',
                differentBankAccount: false,
                lastFourSSN: ''
            },
            setPrimaryPayment: false,
            bankName: '',
            bankCheckType: 'Consumer'
        };
    }
    open(content) {
        this.modalReference = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    addBankAcct() {
        this.bankJson();
        this.open(this.addbankacct);
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    setSSNBox(boxValue) {
        this.ssnBox = boxValue;
    }
    // Edit details
    editBankDetails(account, event) {
        if (event.preventDefault) {
            event.preventDefault();
        }
        else {
            event.returnValue = false;
        }
        this.edit = 'yes';
        this.accountEditSaved = account;
        this.open(this.addbankacct);
        this.bankDetails.bankAccount.bankAccountNumber = this.saveBankData.accountNumber;
        this.bankDetails.bankAccount.routingNumber = this.saveBankData.routingNumber;
        // this.bankDetails.bankName = this.bankDetails.bankName;
        // this.bankDetails.bankCheckType = this.bankDetails.bankCheckType;
        if (this.saveBankData.defaultPaymentMethod) {
            this.bankDetails.setPrimaryPayment = true;
        }
        this.bankDetails.bankCheckType = this.checkType_edit_saved;
    }
    clearPopup() {
        this.bankJson();
        this.edit = 'no';
        this.modalReference.close();
    }
    deletePopup(card) {
        // this.deleteId = card.ccRepositoryId;
        this.open(this.deleteCardO);
    }
}
exports.CSPrimaryBankComponent = CSPrimaryBankComponent;
//# sourceMappingURL=primarybank.component.js.map